import { put, call, delay } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK, UNPROCESSABLE_ENTITY } from '../../../configs/serverStatusCodes';
import {
  loadPaymentListFailed,
  loadPaymentListSuccessful,
  loadPaymentListBegin,
} from '../actions';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

const RELATED_FILTER_FIELDS = ['session_id', 'client_id', 'host_id'];

const hasRelatedEntityValidationError = (status, data, pool) => {
  if (status !== UNPROCESSABLE_ENTITY || !data || typeof data !== 'object') {
    return false;
  }

  const errors = data.errors && typeof data.errors === 'object' ? data.errors : {};

  return RELATED_FILTER_FIELDS.some(field => {
    if (!pool[field] || !Array.isArray(errors[field])) {
      return false;
    }

    return errors[field].some(message => {
      if (typeof message !== 'string') {
        return false;
      }

      const normalized = message.toLowerCase();
      return normalized.includes('не существует') || normalized.includes('does not exist');
    });
  });
};

export default function* loadUserList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
      with_host: 1,
      with_session: 1,
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }
    const url = `${BACKEND_URL}/payments`;
    yield put(loadPaymentListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === OK) {
      data.result = data.data;
      yield put(loadPaymentListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else if (hasRelatedEntityValidationError(dataResponse.status, data, pool)) {
      const emptyData = {
        data: [],
        result: [],
        meta: {
          page,
          limit,
          total: 0,
        },
      };
      yield put(loadPaymentListSuccessful(emptyData));
      yield call(resolveActionPromise(action, emptyData));
    } else {
      yield put(loadPaymentListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadPaymentListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
